const followupsApiFactory = (axios) => ({
  createFollowup: async (body) => (await axios.post(`/followups`, body)).data.data,
  getFollowUpTypes: async (filter, opt) =>
    (await axios.get(`/followUpType/all`, { params: { filter, ...opt } })).data.data,
});

export { followupsApiFactory };
